import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import theme from 'src/styles/components/CarouselItem.module.scss';

const CarouselItem = memo(({ style, isActive, children }) => (
    <div className={classnames(theme.container, { [theme.active]: isActive })} style={style}>
        {children}
    </div>
));

CarouselItem.propTypes = {
    style: PropTypes.object,
    isActive: PropTypes.bool,
    item: PropTypes.shape({
        params: PropTypes.shape({
            searchString: PropTypes.string
        }),
        name: PropTypes.string,
        positions: PropTypes.arrayOf(PropTypes.object),
        status: PropTypes.number.isRequired,
        id: PropTypes.string.isRequired
    }),
    children: PropTypes.node
};

export default CarouselItem;
